import { useCallback, useRef, useState } from 'react';

/**
 * A question put to the person before going on: `ask` resolves with their `answer`, and `pending` is what the
 * question is about until then. A second question cancels the first, which would otherwise never resolve.
 */
export const useConfirmation = <Subject>() => {
    const [pending, setPending] = useState<Subject>();
    const resolveRef = useRef<(confirmed: boolean) => void>(undefined);

    const ask = useCallback(
        (subject: Subject) =>
            new Promise<boolean>((resolve) => {
                resolveRef.current?.(false);
                resolveRef.current = resolve;
                setPending(subject);
            }),
        [],
    );

    const answer = useCallback((confirmed: boolean) => {
        resolveRef.current?.(confirmed);
        resolveRef.current = undefined;
        setPending(undefined);
    }, []);

    return { pending, ask, answer };
};
